import { Typography } from 'antd';
import { type TFunction, useTranslation } from 'react-i18next';
import {
    ApplyEmptyLayoutOnRouterDocument,
    type ApplyEmptyLayoutOnRouterMutation,
    type ApplyEmptyLayoutOnRouterMutationVariables,
} from '../../../../../../api/mutations/applyEmptyLayoutOnRouter';
import { type LayoutImplementation } from './types';

const implementation: LayoutImplementation<null, null> = {
    getTitle: (t: TFunction) => t('routerDetails:layouts.none.title'),
    ViewPanelComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return <Typography.Paragraph>{t('routerDetails:layouts.none.description')}</Typography.Paragraph>;
    },
    FormComponent: () => null,
    applyRouter: (apolloClient, routerId, settings) =>
        apolloClient.mutate<ApplyEmptyLayoutOnRouterMutation, ApplyEmptyLayoutOnRouterMutationVariables>({
            mutation: ApplyEmptyLayoutOnRouterDocument,
            variables: { routerId },
        }),
    defaultSettings: null,
    getInitialValues: () => null,
};

export default implementation;
